const jp = {
  nav_gallery: "修復事例",
  nav_pricing: "料金表",
  nav_b2b: "法人提携",
  nav_contact: "お問い合わせ",
  nav_hours: "営業時間：10:00〜18:00",
  nav_cta: "簡単見積もり",
  nav_scroll_top: "ページトップへ",

  hero_h1: "純正の質感を再現し",
  hero_h2: "資産価値を守る",
  hero_badge: "最短2日仕上げ / 写真見積もり対応",
  hero_delivery: "全国郵送対応",
  hero_speed: "写真査定10分以内回答",
  hero_btn_gallery: "修復事例を見る",
  hero_btn_pricing: "料金を確認する",

  why_title: "選ばれる理由",
  why_subtitle: "他店にはない2つの強みが、私たちを選ぶ決め手になっています",
  why_speed_label: "スピード",
  why_speed_title: "業界最速\n最短2日納期",
  why_speed_desc: "同業他社の多くは最低でも1週間以上お時間をいただきますが、当店では最短2日での仕上げを実現。急ぎのご依頼にも柔軟に対応いたします。",
  why_speed_other_label: "他店の納期",
  why_speed_other_val: "1週間〜",
  why_speed_us_label: "当店の納期",
  why_speed_us_val: "最短2日〜",
  why_quality_label: "品質保証",
  why_quality_title: "修復後30日間\n品質保証",
  why_quality_desc: "修復後30日以内に通常範囲内での不具合は、無償で再修復いたします。安心してお任せください。",
  why_quality_target_label: "保証対象",
  why_quality_target_val: "日常使用による損傷",
  why_quality_period_label: "保証期間",
  why_quality_period_val: "修復後30日以内",

  gallery_label: "リペア事例",
  gallery_cta: "無料見積もりを依頼する",
  gallery_repair_0: "革キズ修復・穴埋め",
  gallery_repair_1: "精巧な描画",
  gallery_repair_2: "金具メッキ再生",
  gallery_repair_3: "バッグ表面黒染",
  gallery_repair_4: "金具焼付塗装修復",
  gallery_repair_5: "汚れ落とし",

  pricing_label: "Pricing",
  pricing_title: "リペア メニュー",
  pricing_subtitle: "お客様のニーズに合わせて選べる2つのプラン",
  pricing_badge_flat: "見積もり不要・一律料金",
  pricing_badge_no_extra: "複雑な修復も追加料金なし",
  pricing_pack_title: "定額パック",
  pricing_pack_popular: "人気No.1",
  pricing_pack_size_s: "バッグサイズ 〜20cm",
  pricing_pack_size_m: "バッグサイズ 20〜30cm",
  pricing_pack_size_l: "バッグサイズ 30〜40cm",
  pricing_include_0: "クレンジング",
  pricing_include_1: "コーナー補修（全箇所）",
  pricing_include_2: "エッジペイント全周塗り直し",
  pricing_include_3: "ハンドル補修",
  pricing_include_4: "ロゴ補修",
  pricing_include_5: "金具磨き",
  pricing_include_6: "仕上げコーティング",
  pricing_pack_cta: "このプランを選ぶ",
  pricing_single_title: "単品メニュー",
  pricing_single_subtitle: "部位別にカスタムオーダー可能",
  pricing_si_0: "クレンジング",
  pricing_si_1: "皮革修復再生",
  pricing_si_2: "コバ処理",
  pricing_si_3: "黒染・各種色染",
  pricing_si_4: "内張り補修",
  pricing_si_5: "アクセサリーパーツ修理",
  pricing_si_6: "PVC素材復元",
  pricing_si_7: "精巧な描画",
  pricing_si_8: "エナメル(琺瑯)修復",
  pricing_si_9: "金具メッキ加工",
  pricing_note_1: "表示価格はすべて税込みです。素材・損傷の状態により価格が変動する場合があります。写真をお送りいただければ、10分以内に正確なお見積もりをご提示します。",
  pricing_note_2: "上記以外の修復項目もお気軽にご相談ください。専門スタッフが丁寧に対応いたします。",
  pricing_xl_title: "特大サイズ・特殊形状・スーツケースも対応",
  pricing_xl_desc: "S〜Lサイズ範囲外の特大バッグ、特殊な形状のアイテム、スーツケースなどは個別にお見積りいたします。まずはお気軽にお問い合わせください。",
  pricing_xl_cta: "個別相談・お見積り",

  process_label: "How It Works",
  process_title: "簡単「宅配修理」の流れ",
  process_subtitle: "自宅にいながら、全国どこからでもご利用いただけます",
  process_step_1_title: "お問い合わせ",
  process_step_1_desc: "LINE・WeCom・メールにてお気軽にご連絡ください。写真を送るだけでOKです。",
  process_step_2_title: "お見積もり",
  process_step_2_desc: "受信後、最短10分でお見積もりをご回答。金額にご納得いただいてからご依頼ください。",
  process_step_2_badge: "最短10分",
  process_step_3_title: "商品をご発送",
  process_step_3_desc: "見積もり後,品物をお送りください。　　ご発送お願いしております。",
  process_step_4_title: "修理・修復作業",
  process_step_4_desc: "熟練職人が丁寧に修復いたします。作業期間は最短2日〜で対応可能です。",
  process_step_4_badge: "最短2日",
  process_step_5_title: "ご返送",
  process_step_5_desc: "修復完了後、丁寧に梱包してご返送いたします。仕上がりをご確認ください。",

  b2b_badge: "法人提携",
  b2b_title: "古物商様向け",
  b2b_highlight: "\u3000特別パートナープログラム",
  b2b_desc: "高級中古品の買取・販売を行う古物商様に特化したBtoBプログラムです。修復品質の向上と業務効率化を同時に実現し、お客様のビジネス競争力を強力にサポートします。",
  b2b_stat_0_val: "50%",
  b2b_stat_0_label: "納期短縮率",
  b2b_stat_0_sub: "一般比",
  b2b_stat_1_val: "2日〜",
  b2b_stat_1_label: "最短納期",
  b2b_stat_1_sub: "法人専用レーン",
  b2b_stat_2_val: "30日",
  b2b_stat_2_label: "品質保証期間",
  b2b_stat_2_sub: "無償対応",
  b2b_stat_3_val: "全国",
  b2b_stat_3_label: "対応エリア",
  b2b_stat_3_sub: "郵送受付",
  b2b_benefit_0_title: "掛け払い対応",
  b2b_benefit_0_desc: "月10点以上のご利用で翌月末一括清算。キャッシュフロー管理が容易になります。",
  b2b_benefit_1_title: "優先処理レーン",
  b2b_benefit_1_desc: "法人パートナー様の修復品は専用レーンで最優先処理。通常比50%短縮の納期を実現。",
  b2b_benefit_2_title: "専任担当者配置",
  b2b_benefit_2_desc: "専属の担当者がつき、進捗確認・品質フィードバックをワンストップで対応。",
  b2b_benefit_3_title: "品質管理レポート",
  b2b_benefit_3_desc: "修復ごとに詳細な品質管理レポートを発行。お客様への説明資料としてもご活用いただけます。",
  b2b_target_label: "こんな方にぴったり",
  b2b_target_0: "リサイクルショップ・質屋",
  b2b_target_1: "高級中古品買取・販売業者",
  b2b_target_2: "フリマアプリ大量出品者",
  b2b_target_3: "百貨店・セレクトショップ",
  b2b_target_4: "ホテル・旅館クロークサービス",
  b2b_cta_note: "まずはお気軽にご相談ください。専任担当者が詳しくご案内いたします。",
  b2b_cta_btn: "提携申込みはこちら",

  contact_label: "Contact",
  contact_title: "お問い合わせ",
  contact_subtitle_1: "写真査定10分以内回答",
  contact_subtitle_2: "写真を送るだけで見積もり可能",
  contact_ch_0_name: "LINE相談",
  contact_ch_0_target: "日本のお客様向け",
  contact_ch_0_desc: "友だち追加後、バッグの写真をお送りください。10分以内にお見積もりをご返信します。",
  contact_ch_1_name: "WeCom相談",
  contact_ch_1_target: "中国語圏のお客様向け",
  contact_ch_1_desc: "企業微信（WeCom）でのご相談に対応。中国語でお気軽にお問い合わせいただけます。",
  contact_ch_2_name: "メール相談",
  contact_ch_2_target: "法人様向け",
  contact_ch_2_desc: "法人様・古物商様のお問い合わせはこちら。メールにてお気軽にご連絡ください。",
  contact_logistics_1: "全国郵送対応（送料お客様負担）",
  contact_logistics_2: "営業時間：平日 10:00〜18:00",
  contact_mail_title: "メールでのお問い合わせ",
  contact_mail_desc: "下記ボタンよりメールをお送りください。バッグの写真・ブランド・修復箇所をご記載いただくと、よりスムーズにご対応できます。",
  contact_mail_tmpl_label: "メール本文テンプレート",
  contact_mail_tmpl_0: "お名前",
  contact_mail_tmpl_1: "ご希望サービス（定額パック S / M / L、単品など）",
  contact_mail_tmpl_2: "バッグのブランド・サイズ",
  contact_mail_tmpl_3: "修復箇所・ご要望",
  contact_mail_tmpl_4: "バッグの写真（添付）",
  contact_mail_cta_btn: "メールアプリで開く",
  contact_line_add_btn: "LINEで友だち追加",
  contact_wecom_add_btn: "WeComで直接連絡",
  contact_mail_after: "写真が届き次第、最短10分でお見積もりをご返信します。",
  contact_mail_subject: "お見積もりのご依頼",
  contact_mail_body: "お名前：\nご希望サービス：\nバッグのブランド・サイズ：\n修復箇所・ご要望：\n\n※バッグの写真も合わせてお送りください。",

  company_title: "会社概要",
  ci_company: "会社名",
  ci_rep: "代表者名",
  ci_license: "古物許可証",
  ci_address: "所在地",
  ci_hours: "営業時間",
  ci_area: "対応エリア",
  ci_brands: "主な取扱ブランド",
  ci_email_label: "メールアドレス",
  ci_hours_val: "10:00〜18:00（土日祝定休）",
  ci_area_val: "全国（郵送対応）",

  footer_band_delivery: "全国郵送対応",
  footer_band_speed: "写真査定10分以内回答",
  footer_band_hours: "平日 10:00〜18:00",
  footer_desc: "純正の質感を再現し、資産価値を守る。大阪の自社工房で、ハイエンドバッグの修復・復元を承ります。",
  footer_services_title: "サービス",
  footer_link_0: "定額パック",
  footer_link_1: "単品メニュー",
  footer_link_2: "修復事例",
  footer_link_3: "法人提携",
  footer_link_4: "お問い合わせ",
  footer_contact_title: "お問い合わせ",
  footer_sns_title: "Follow Us",
  footer_copyright: "© 2025 蔵新 OSAKA ATELIER. All rights reserved.",
  footer_privacy: "プライバシーポリシー",
  footer_law: "特定商取引法に基づく表記",
};

export default jp;
